import "./index.scss";

import { Stack } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { ReactComponent as CSVIcon } from "assets/images/icons/document-csv.svg";
import { ReactComponent as PDFIcon } from "assets/images/icons/document-pdf.svg";
import { ReactComponent as ExcelIcon } from "assets/images/square-buttons/document-excel.svg";
import { ReactComponent as PrintIcon } from "assets/images/square-buttons/print.svg";
import { TReportTableOptions } from "modules/api/type";
import moment from "moment";
import { CSVLink } from "react-csv";

export const ReportTableOptions = ({
  title,
  subtitle = "",
  type,
  showOptions,
  onClickPdf,
  onClickPrint,
  csvData,
  onExcelFile,
  containerStyle = {},
  isLoading = false,
}: TReportTableOptions) => {
  const filename = `${moment().format("DD/MM/YYYY")}-${type}-report`;
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      mt="20px"
      className="report-table-options-container"
      style={containerStyle}
    >
      <Stack>
        <h2>{title}</h2>
        <p className="subtitle">{subtitle}</p>
      </Stack>
      {showOptions ? (
        isLoading ? (
          <p className="subtitle">Loading options...</p>
        ) : (
          <Stack alignItems="center" direction="row" spacing={1}>
            <IconButton aria-label="export pdf" component="span" onClick={onClickPdf}>
              <PDFIcon />
            </IconButton>
            {csvData && (
              <IconButton aria-label="export csv" component="span">
                <CSVLink
                  data={csvData}
                  filename={`${filename}.csv`}
                  style={{ height: 18, width: 18 }}
                >
                  <CSVIcon style={{ marginBottom: 6 }} />
                </CSVLink>
              </IconButton>
            )}
            {onExcelFile && (
              <IconButton
                aria-label="export pdf"
                component="span"
                onClick={() => onExcelFile(filename)}
              >
                <ExcelIcon style={{ height: 24, width: 24 }} />
              </IconButton>
            )}
            <IconButton aria-label="print" component="span" onClick={onClickPrint}>
              <PrintIcon />
            </IconButton>
          </Stack>
        )
      ) : null}
    </Stack>
  );
};
